module.exports = __webpack_public_path__ + "static/media/jumpy_scribble.4c5d6732.gif";